<template>
  <v-dialog
    ref="dialog"
    :value="value"
    persistent
    fullscreen
    :overlay="true"
    scrollable
    class="ma-0 pa-0"
  >
    <v-card
      v-if="value"
      class="ft-editor-dialog-content"
    >
      <page-bar
        title="User Select"
        :context-menu="selectorContextMenu"
        :loading="loading"
        :fixed="true"
        :hide-page-scrollbar="value"
      >
        <template slot="bar-right">
          <slot name="bar-right" />
        </template>
        <template slot="default">
          <slot name="before-progress" />
        </template>
        <template slot="after-progress">
          <slot name="after-progress" />
        </template>
      </page-bar>
      <v-card-text
        id="ft-user-select-scroll-window"
        v-scroll:#ft-user-select-scroll-window="dialogScroll"
        class="ma-0 pa-0 pb-3"
      >
        <api-errors :errors="errors" />
        <v-layout
          wrap
        >
          <v-flex
            v-for="(user, i) in terminalUsersFiltered"
            :key="i"
            class="my-2"
            xs12
            sm6
            md4
            lg3
          >
            <v-card
              tile
              hover
              class="mx-2"
              height="100%"
              :ripple="true"
              @click.native="switchUser(user)"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 mb-1">
                    {{ user.nameFull }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <!-- Clocked In: {{ user.clockedIn }} -->
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-avatar
                  size="80"
                >
                  <img
                    v-if="user.photoUrlFull"
                    :src="user.photoUrlFull"
                  ><v-icon
                    v-else
                    size="80"
                    color="grey darken-1"
                  >
                    mdi-account-circle
                  </v-icon>
                </v-list-item-avatar>
              </v-list-item>

              <v-card-actions>
                <!-- <v-btn text>
                  Clock Out
                </v-btn>
                <v-btn text>
                  Clock In
                </v-btn> -->
                <v-chip
                  v-if="user.clockedIn"
                  :color="clockInColor(user.clockedIn)"
                  text
                >
                  <v-avatar left>
                    <v-icon>mdi-clock-outline</v-icon>
                  </v-avatar>
                  {{ formatClockIn(user.clockedIn) }}
                </v-chip>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- empty v-card-actions helps data float to top -->
      <v-card-actions class="ma-0 pa-0" />
      <v-dialog
        v-model="passwordPrompt"
        max-width="320"
      >
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h6 mb-1">
                {{ selectedUser.nameFull }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  v-if="usePin"
                  ref="pinInput"
                  v-model="pinValue"
                  type="number"
                  :loading="loggingIn"
                  pattern="[0-9]"
                  class="ft-fake-password"
                  label="PIN"
                  :error-messages="loginErrorMessages"
                  :autocomplete="false"
                />
                <v-text-field
                  v-else
                  ref="passwordInput"
                  v-model="passwordValue"
                  label="Password"
                  type="text"
                  :loading="loggingIn"
                  class="ft-fake-password"
                  append-icon="mdi-arrow-right-circle"
                  :error-messages="loginErrorMessages"
                  :autocomplete="false"
                  @click:append="enterPassword"
                  @keydown.enter="enterPassword"
                />
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
              size="80"
            >
              <img
                v-if="selectedUser.photoUrlFull"
                :src="selectedUser.photoUrlFull"
              ><v-icon
                v-else
                size="80"
                color="grey darken-1"
              >
                mdi-account-circle
              </v-icon>
            </v-list-item-avatar>
          </v-list-item>

          <v-card-actions v-if="selectedUser.usesPin">
            <v-checkbox
              v-if="!selectedUser.clockedIn"
              v-model="clockInValue"
              label="Clock In"
            />
            <v-spacer />

            <v-btn
              text
              :loading="loggingIn"
              @click="setUsePin(!usePin)"
            >
              {{ usePin ? 'Use Password' : 'Use Pin' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loginOtherPrompt"
        max-width="320"
      >
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h6 mb-1">
                <v-text-field
                  ref="userInput"
                  v-model="usernameValue"
                  label="Username"
                  type="text"
                  :loading="loggingIn"
                  :error="!!loginErrorMessages[0]"
                  :autocomplete="false"
                  @keydown.enter="$refs.otherPasswordInput.focus()"
                />
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  ref="otherPasswordInput"
                  v-model="passwordValue"
                  label="Password"
                  type="text"
                  :loading="loggingIn"
                  class="ft-fake-password"
                  :error-messages="loginErrorMessages"
                  :autocomplete="false"
                  @keydown.enter="loginOther"
                />
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
              size="80"
            >
              <v-icon
                size="50"
                color="grey darken-1"
              >
                mdi-account-question
              </v-icon>
            </v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              color="primary"
              :loading="loggingIn"
              @click="loginOther"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import navRoute from '../mixins/navRoute'
import errorHandler from '../mixins/errorHandler'
import moment from 'moment-timezone'
import {NoAccessRouteName, EmptyRoutePath, NotFoundRouteName} from '../store/modules/menu'

export default {
  name: 'UserSelectDialog',
  mixins: [navRoute, errorHandler],
  props: {
    // Page Bar
    title: String,
    contextMenu: Array,
    loading: Boolean,
    value: Boolean
  },

  data: function () {
    return {
      loginOtherPrompt: false,
      dialogScrollTimeout: null,
      terminalUsers: [],
      recoveryTimer: null,
      allowRecovery: true,
      usePin: false,
      selectedStaffId: null,
      usernameValue: null,
      passwordValue: null,
      clockInValue: false,
      pinValue: null,
      loginErrorMessages: [],
      loggingIn: false
    }
  },
  computed: {
    selectorContextMenu () {
      return [
        {title: 'Login Other', icon: 'mdi-login', action: () => {this.showloginOtherPrompt()}},
        {title: 'Shut Down Terminal', icon: 'mdi-power', action: () => {this.$ftAPI().logoutPrompt()}}
      ]
    },
    currentTerminalUser () {
      const currentUserId = this.$ftUser.staffId
      return this.terminalUsers.find(u => u.staffId === currentUserId)
    },
    terminalUsersFiltered () {
      const cu = this.$ftUser
      const ctu = this.currentTerminalUser || {
        staffId: cu.staffId,
        username: cu.username,
        photoUrlFull: cu.photoUrl,
        nameFull: cu.name,
        nameProper: cu.nameProper,
        usesPin: cu.usesPin,
        clockedIn: cu.clockedIn
      }
      return (!ctu.staffId ? [] : [ctu]).concat(this.terminalUsers.filter(u => u.staffId !== ctu.staffId))
    },
    selectedUser () {
      return this.terminalUsersFiltered.find(u => u.staffId === this.selectedStaffId) || {}
    },
    passwordPrompt: {
      get () {
        return !!this.selectedUser.staffId
      },
      set (val) {
        if (!val) this.selectedStaffId = null
      }
    }
  },
  watch: {
    value (val) {
      if (this.recoveryTimer) {
        clearTimeout(this.recoveryTimer)
        this.recoveryTimer = null
      }
      if (val) {
        this.loginOtherPrompt = false
        this.passwordPrompt = false
        this.loadTerminalUsers()
        this.allowRecovery = true
        this.recoveryTimer = setTimeout(() => {
          this.allowRecovery = false
        }, this.$ftAC.recoveryTime)
      }
    },
    passwordValue (v, old) {
      if (v !== old) {
        this.loginErrorMessages = []
      }
    },
    pinValue (v, old) {
      const pinLength = this.$ftAC.pinLength
      if (v !== old) {
        this.loginErrorMessages = []
      }
      console.log('Pin Entered', v)
      if (this.passwordPrompt && typeof v === 'string' && v.length === pinLength) {
        this.$ftAPI().get(this.authCommand(this.selectedUser.username, v, null, this.clockInValue && !this.selectedUser.clockedIn))
      }
      if (typeof v === 'string' && v.length > pinLength) {
        setTimeout(()=>{this.pinValue = this.pinValue.substring(0, pinLength)}, 0)
      }
    },
    passwordPrompt (val) {
      if (val) {
        this.clockInValue = !!this.terminalUsers.find(u => u.staffId === this.selectedStaffId)
      }
    }
  },
  mounted () {
    console.warn('User Select Dialog Open - 1', this.$refs.dialog)
    if (this.$ftAPI().getGlobalAppState().userLock) {
      console.error('Loading loadTerminalUsers')
      this.loadTerminalUsers()
    } else {
      console.error('Not Loading loadTerminalUsers')
    }
  },
  methods: {
    clockInColor (timestamp) {
      const dt = this.$ftAPI().clubMoment(timestamp)
      const cdt = this.$ftAPI().clubMoment()
      const duration = moment.duration(cdt.diff(dt))
      return duration.asHours() > 8 ? 'error' : 'info'
    },
    formatClockIn (timestamp) {
      const dt = this.$ftAPI().clubMoment(timestamp)
      const cdt = this.$ftAPI().clubMoment()
      const duration = moment.duration(cdt.diff(dt))
      var t
      if (duration.asMinutes() > 59) {
        t = Math.round(duration.asHours() * 10) / 10 + ' hrs.'
      } else {
        t = Math.floor(duration.asMinutes()) + ' min.'
      }
      return dt.format('MMM, D h:mm A') + ' (' + t + ')'
    },
    enterPassword () {
      this.$ftAPI().get(this.authCommand(this.selectedUser.username, null, this.passwordValue, this.clockInValue && !this.selectedUser.clockedIn))
    },
    terminalUsersCommand () {
      return [
        {
          command: 'staffToTerminalGroup',
          load: this.terminalUsers,
          loading: this.setIsLoading,
          error: (r) => {
            console.error('staffToTerminalGroup lookup error', r)
          },
          params: {
            children: true,
            include_fields: ['photoUrlFull', 'nameFull', 'nameProper', 'staffId', 'clockedIn', 'clockedInFor', 'usesPin', 'username'],
            filter_methods: {filterFieldValue: ['terminalGroupId', this.$ftAC.terminal.terminalGroupId]},
            // filter: [{field: 'id', operator: 'EQUAL', values: ['???']}]
          }
        }
      ]
    },
    authCommand (username, pin, password, clockIn, clockOut) {
      if (this.loggingIn) return
      const terminalJwt = this.$ftAPI().getGlobalAppState().jwt
      return [
        {
          command: 'authenticateApp',
          load: (r) => {
            const record = r[0]
            const nextuser = record.user
            // Don't load JWTs from responses for a minute to block any in flight requests from overriding a recently changed jwt
            this.$ftAPI().setSkipResponseToken(Date.now() + 60000)
            // Update access token
            this.$ftAPI().setAccessToken(record.jwt)
            // Same as existing user?
            const sameUser = this.$ftUser.username === nextuser.username
            // Update currently logged in user
            this.$ftAPI().setUser(nextuser)
            this.passwordPrompt = false
            // Close window
            this.$ftAPI().setGlobalAppState({userLock: false})
            // Navigate to home screen if not same user
            this.loggingIn = false
            if (!sameUser) setTimeout(()=>{
              // this.$router.go('/')
            }, 0)
            setTimeout(()=>{
              const router = this.$router
              const currentRoute = router.currentRoute
              const shouldBe = router.match(currentRoute.fullPath)
              if (shouldBe.name !== currentRoute.name && !currentRoute.query.sk && (currentRoute.name === NotFoundRouteName || shouldBe.name === NoAccessRouteName)) {
              // Hack to refresh current route
                router.replace(EmptyRoutePath)
                router.replace(currentRoute.fullPath)
              }
            }, 0)
          },
          loading: (v) => {
            this.loggingIn = v
          },
          error: (r) => {
            this.loggingIn = false
            this.loginErrorMessages = [r.error]
            console.error('authenticateApp error', r)
          },
          params: {
            filter_methods: {terminalUser: [this.$ftAPI().appMode(), terminalJwt, username, pin, password, clockIn || false, clockOut || false]}
          }
        }
      ]
    },
    loadTerminalUsers () {
      this.$ftAPI().get(this.terminalUsersCommand())
    },
    switchUser (user) {
      this.selectedStaffId = user.staffId
      this.setUsePin(user.usesPin)
    },
    showloginOtherPrompt () {
      this.usernameValue = null
      this.passwordValue = null
      this.loginOtherPrompt = true
    },
    loginOther () {
      this.$ftAPI().get(this.authCommand(this.usernameValue, null, this.passwordValue))
    },
    dialogScroll (e) {
      // Unfortunately, "attach" on v-select. v-autocomplete, v-menu, etc., doesn't work all the time, so they only scroll with the main body, not the scrollable content in a v-dialog.
      // We'll need to iterate through all children to force any of these open components to reposition after a v-dialog scrolls.
      // clearTimeout(this.dialogScrollTimeout)
      // this.dialogScrollTimeout = setTimeout(() => updateMenuDimensionsOfChildren(this.$refs.editForm), 100)
    },
    setUsePin (v) {
      this.usePin = v
      this.passwordValue = null
      this.pinValue = null
      this.loggingIn = false
      this.loginOtherPrompt = false
      this.loginErrorMessages = []
      setTimeout(() => {
        var ref
        if (this.usePin) {
          ref = this.$refs.pinInput
        } else {
          ref = this.$refs.passwordInput
        }
        if (ref) ref.focus()
      }, 0)
    }
  }

}
</script>
